/**
 * gd-checkout-utm.js — carrega os parâmetros de campanha ATÉ A URL DO CHECKOUT
 *
 * ─── POR QUE ESTE ARQUIVO EXISTE ────────────────────────────────────────────
 * O Triple Whale (TriplePixel) captura `location.href` e `document.referrer` —
 * está no snippet do pixel no theme.liquid (`u: location.href, r: document.referrer`),
 * e o comentário lá diz: "cada LP é diferenciada pelo location.href que o pixel
 * captura". Ou seja: ele lê a URL. **Cart attribute é invisível pra ele.**
 *
 * As LPs iam pro checkout com `location.href = '/checkout'` — URL limpa, sem
 * nenhum parâmetro. O checkout virava "sessão nova" pro Triple Whale (reportado
 * pela consultoria de tracking em 27/Jul/2026). Este helper anexa os parâmetros
 * de campanha nessa navegação final.
 *
 * ─── POR QUE NÃO CART PERMALINK ─────────────────────────────────────────────
 * A consultoria sugeriu trocar tudo por `/cart/{variantId}:{qty}` e dispensar o
 * app de brinde. Isso QUEBRARIA a oferta da OAK e da garrafa: o Vex Auto Add To
 * Cart não só adiciona o pote grátis, ele aplica o desconto automático
 * `FRUTASVERMELHASGRATIS` que ZERA o preço dele. Sem o app o cliente pagaria os 3
 * potes. Além disso o carrinho da OAK é dinâmico (o cliente escolhe a combinação
 * de sabores), então não existe um conjunto fixo de variant IDs por botão.
 *
 * Este helper resolve o mesmo problema SEM tocar na mecânica comercial: o
 * `/cart/add.js` continua rodando (o Vex age no carrinho, antes do checkout) e só
 * a navegação final ganha os parâmetros.
 *
 * ─── VALIDADO CONTRA A LOJA REAL (28/Jul/2026) ──────────────────────────────
 *   /cart/add?...&return_to=/checkout?utm_source=teste
 *     → 302 → guday.com.br/checkout?utm_source=teste
 *   /discount/CODE?redirect=/checkout?utm_source=teste
 *     → 302 → guday.com.br/checkout?utm_source=teste
 * Os dois caminhos preservam a query string até o checkout.
 *
 * ─── USO ────────────────────────────────────────────────────────────────────
 *   window.location.href = gdCheckoutUrl('/checkout');
 *   window.location.href = gdCheckoutUrl('/discount/X?redirect=/checkout');  // trata o redirect aninhado
 *
 * ⚠️ NÃO substitui o `_lp_source`/`_utm_*` gravados no cart: aqueles viram
 * note_attributes no pedido (Admin API). Este helper é pro pixel, que só lê URL.
 * Os dois eixos coexistem de propósito.
 */
(function () {
  'use strict';
  if (window.gdCheckoutUrl) return;   // idempotente

  var KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term',
              'fbclid','gclid','ttclid'];

  // Origem 1: a própria URL (com o gd-utm-passthrough.js no ar, a UTM costuma
  // estar aqui durante toda a navegação da LP).
  function fromUrl() {
    var out = {};
    try {
      var qs = new URLSearchParams(window.location.search);
      KEYS.forEach(function (k) { var v = qs.get(k); if (v) out[k] = v; });
    } catch (e) {}
    return out;
  }

  // Origem 2 (fallback): o cookie do utm-tracker.js, que guarda a UTM da entrada
  // por 30d. Cobre o caso de o cliente ter navegado e perdido a UTM da URL.
  function fromCookie() {
    var out = {};
    try {
      var m = document.cookie.match(/(^|;\s*)gd_utm=([^;]*)/);
      if (!m) return out;
      var o = JSON.parse(decodeURIComponent(m[2]));
      if (!o || typeof o !== 'object') return out;
      ['source','medium','campaign','content','term'].forEach(function (f) {
        if (typeof o[f] === 'string' && o[f]) out['utm_' + f] = o[f];
      });
    } catch (e) {}
    return out;
  }

  function params() {
    var url = fromUrl();
    if (Object.keys(url).length) return url;   // a URL manda (mais recente)
    return fromCookie();
  }

  /**
   * Anexa os parâmetros de campanha a uma URL de checkout.
   * Se o destino for `/discount/CODE?redirect=<dest>`, os parâmetros entram no
   * `redirect` (destino final), não no wrapper — senão morreriam no 302.
   */
  window.gdCheckoutUrl = function (target) {
    try {
      target = target || '/checkout';
      var p = params();
      if (!Object.keys(p).length) return target;

      // caso /discount/CODE?redirect=<dest> → recursão no destino real
      var m = /^(\/discount\/[^?]+\?redirect=)(.*)$/.exec(target);
      if (m) {
        var inner = decodeURIComponent(m[2]);
        return m[1] + encodeURIComponent(window.gdCheckoutUrl(inner));
      }

      var hash = '';
      var h = target.indexOf('#');
      if (h !== -1) { hash = target.slice(h); target = target.slice(0, h); }

      var q = target.indexOf('?');
      var base = q === -1 ? target : target.slice(0, q);
      var existing;
      try { existing = new URLSearchParams(q === -1 ? '' : target.slice(q + 1)); }
      catch (e) { return target + hash; }

      Object.keys(p).forEach(function (k) {
        if (!existing.has(k)) existing.append(k, p[k]);   // param já no link vence
      });

      var qs = existing.toString();
      return base + (qs ? '?' + qs : '') + hash;
    } catch (e) {
      return target || '/checkout';   // nunca pode bloquear a compra
    }
  };
})();
